/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OpenVehicleForBackofficeUserMutationVariables = Types.Exact<{
  input: Types.OpenVehicleBackofficeSelfUserInput
}>

export type OpenVehicleForBackofficeUserMutation = {
  __typename?: 'Mutation'
  openVehicleForBackofficeUser: {
    __typename?: 'VehicleInteractionResponse'
    interactionID: string | null
    errors: Array<Types.VehicleInteractionError>
  }
}

export const OpenVehicleForBackofficeUserDocument = gql`
    mutation openVehicleForBackofficeUser($input: OpenVehicleBackofficeSelfUserInput!) {
  openVehicleForBackofficeUser(input: $input) {
    interactionID
    errors
  }
}
    `
export type OpenVehicleForBackofficeUserMutationFn = Apollo.MutationFunction<
  OpenVehicleForBackofficeUserMutation,
  OpenVehicleForBackofficeUserMutationVariables
>

/**
 * __useOpenVehicleForBackofficeUserMutation__
 *
 * To run a mutation, you first call `useOpenVehicleForBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenVehicleForBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openVehicleForBackofficeUserMutation, { data, loading, error }] = useOpenVehicleForBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenVehicleForBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OpenVehicleForBackofficeUserMutation,
    OpenVehicleForBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OpenVehicleForBackofficeUserMutation,
    OpenVehicleForBackofficeUserMutationVariables
  >(OpenVehicleForBackofficeUserDocument, options)
}
export type OpenVehicleForBackofficeUserMutationHookResult = ReturnType<
  typeof useOpenVehicleForBackofficeUserMutation
>
export type OpenVehicleForBackofficeUserMutationResult =
  Apollo.MutationResult<OpenVehicleForBackofficeUserMutation>
export type OpenVehicleForBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    OpenVehicleForBackofficeUserMutation,
    OpenVehicleForBackofficeUserMutationVariables
  >
